import { isRailBookers } from './brand'
import { every, inInclusiveRange, some } from '../utilities/filters/validators'

export const filterKeys = {
  countries: 'countries',
  destinationCount: 'destinationCount',
  destinationEnd: 'destinationEnd',
  destinationIncludes: 'destinations',
  destinationStart: 'destinationStart',
  duration: 'duration',
  famousRoutes: 'famousRoutes',
  nationalParks: 'nationalParks',
  regions: 'regions',
  trains: 'trains',
  vacationTypes: 'vacationTypes',
}

export const filtersRequiringDestinations = [
  filterKeys.destinationEnd,
  filterKeys.destinationIncludes,
  filterKeys.destinationStart
]

export const filterBarOptions = isRailBookers()
  ? [filterKeys.countries, filterKeys.destinationIncludes, filterKeys.vacationTypes, filterKeys.duration, filterKeys.trains]
  : [filterKeys.nationalParks, filterKeys.destinationIncludes, filterKeys.vacationTypes, filterKeys.duration, filterKeys.famousRoutes]
export const moreFilterOptions = [
  filterKeys.destinationEnd,
  filterKeys.destinationStart,
  filterKeys.destinationCount,
]

export const filters = {
  [`${filterKeys.countries}`]: {
    exactMatchLabel: 'Exclude other countries',
    hasExactMatchOption: true,
    initialState: [],
    label: 'Countries Visited',
    placeholder: 'Choose a country ...',
    validator: every,
  },
  [`${filterKeys.destinationCount}`]: {
    initialState: { min: '', max: ''},
    label: 'Number of Destinations',
    validator: inInclusiveRange,
  },
  [`${filterKeys.destinationEnd}`]: {
    initialState: [],
    label: 'Ending City',
    placeholder: 'Choose a destination ...',
    validator: some,
  },
  [`${filterKeys.destinationIncludes}`]: {
    initialState: [],
    label: isRailBookers()
      ? 'Cities Visited'
      : 'Destination',
    placeholder: isRailBookers()
      ? 'Choose a city ...'
      : 'Choose a destination ...',
    validator: every,
  },
  [`${filterKeys.destinationStart}`]: {
    initialState: [],
    label: 'Departing From',
    placeholder: 'Choose a departing city ...',
    validator: some,
  },
  [`${filterKeys.duration}`]: {
    initialState: { min: '', max: ''},
    label: 'Trip Duration',
    placeholder: 'days',
    validator: inInclusiveRange,
  },
  [`${filterKeys.famousRoutes}`]: {
    initialState: [],
    label: 'Famous Routes',
    validator: every,
  },
  [`${filterKeys.nationalParks}`]: {
    initialState: [],
    label: 'National Parks',
    validator: every,
  },
  [`${filterKeys.regions}`]: {
    initialState: [],
    label: 'Regions',
    placeholder: 'Choose a region ...',
    validator: every,
  },
  [`${filterKeys.trains}`]: {
    initialState: [],
    label: 'Trains',
    placeholder: 'Choose a train ...',
    validator: every,
  },
  [`${filterKeys.vacationTypes}`]: {
    initialState: [],
    label: isRailBookers()
      ? 'Type of Holiday'
      : 'Type of Vacation',
    validator: every,
  },
}
